
import PropTypes from "prop-types";
import { TableActionBar } from "@amzn/meridian/table";
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import HorizontalStickyContainer from "../app/horizontal-sticky-container";
import { getSummaryQuantity } from "../../utilities/parent-child-conversion";
import { convertParentChild } from "../Constants";

function calculateTotals(array) {
  return array.reduce((totals, item) => {
      return {
          totalExpectedUnits: (totals.totalExpectedUnits || 0) + (item.expectedUnits || 0), // Keep forecast as raw value
          totalDockReceived: (totals.totalDockReceived || 0) + getSummaryQuantity(item, 'dockReceived', 'childDockReceived'),
          totalScheduledUnits: (totals.totalScheduledUnits || 0) + getSummaryQuantity(item, 'scheduledUnits', 'childScheduledUnits'),
          totalUnscheduledUnits: (totals.totalUnscheduledUnits || 0) + getSummaryQuantity(item, 'unscheduledUnits', 'childUnscheduledUnits')
      };
  }, {});
}

const HorizontalStickyRow = props => (
  <HorizontalStickyContainer Component={Row} {...props} />
)

const IncomingShipmentsScipActionBar = props => {
  const {  forecasts } = props

  const Wrapper = props.stick ? HorizontalStickyRow : Row

  if (forecasts){
    const totals = calculateTotals(forecasts);
    return (
    <Wrapper widths="fill">
      <TableActionBar alignmentHorizontal="justify">
        <Row>
            <Heading level={6}>Total Forecasted Units:</Heading>
            <Text>{(totals.totalExpectedUnits || 0).toLocaleString()}</Text>
            <Heading level={6}>{`Total Scheduled/Manifested Units${convertParentChild === 1 ? ' Child' : ''}:`}</Heading>
            <Text>{(totals.totalScheduledUnits || 0).toLocaleString()}</Text>
            <Heading level={6}>{`Total Pending/Missing Units${convertParentChild === 1 ? ' Child' : ''}:`}</Heading>
            <Text>{(totals.totalUnscheduledUnits || 0).toLocaleString()}</Text>
            <Heading level={6}>{`Total Dock Received Units${convertParentChild === 1 ? ' Child' : ''}:`}</Heading>
            <Text>{(totals.totalDockReceived || 0).toLocaleString()}</Text>
        </Row>
       
      </TableActionBar>
    </Wrapper>
  )
  }
  
  
}

IncomingShipmentsScipActionBar.propTypes = {
  stick: PropTypes.bool.isRequired,
  forecasts: PropTypes.arrayOf(PropTypes.shape({
    expectedUnits: PropTypes.number,
    dockReceived: PropTypes.number,
    scheduledUnits: PropTypes.number,
    unscheduledUnits: PropTypes.number
  })),
  warehouseId: PropTypes.string
}

export default IncomingShipmentsScipActionBar
